import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { GetOrderVm } from './get-order.vm';

export const getOrder = async (order: string, callback: CallbackObject<GetOrderVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/reception/orders/${encodeURIComponent(order)}`, config);
    callback.success(plainToClass(GetOrderVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
